import { create } from 'zustand';

export const useQuestionLibraryStore = create((set, get) => ({
  // State
  questions: [],
  categories: [],
  isLoading: false,
  hasMore: true,
  error: null,
  
  // Filters
  filters: {
    subject: '',
    gradeLevel: '',
    topic: '',
    difficulty: '',
    questionType: '',
    searchTerm: ''
  },

  // Actions
  setFilters: (newFilters) => {
    set(state => ({
      filters: { ...state.filters, ...newFilters },
      questions: [],
      hasMore: true
    }));
  },

  // Load questions
  loadQuestions: async (loadMore = false) => {
    const { filters, questions } = get();
    
    try {
      set({ isLoading: true, error: null });
      
      // Mock data - replace with actual Firestore query
      const mockQuestions = [
        {
          id: 'q1',
          title: 'Solve for x: 2x + 5 = 13',
          type: 'math',
          subject: 'mathematics',
          gradeLevel: 'grade_9',
          topic: 'algebra',
          difficulty: 'easy',
          points: 2,
          mathContent: '2x + 5 = 13',
          correctAnswer: 'x = 4',
          explanation: 'Subtract 5 from both sides, then divide by 2',
          tags: ['linear equations', 'solving'],
          rating: 4.5,
          views: 324,
          createdAt: new Date('2024-01-10'),
          author: 'Mathematics Department'
        },
        {
          id: 'q2',
          title: 'What is the capital of France?',
          type: 'multiple-choice',
          subject: 'geography',
          gradeLevel: 'grade_8',
          topic: 'world capitals',
          difficulty: 'easy',
          points: 1,
          content: 'What is the capital city of France?',
          options: ['London', 'Berlin', 'Paris', 'Madrid'],
          correctAnswer: 2,
          explanation: 'Paris is the capital and largest city of France.',
          tags: ['geography', 'capitals', 'europe'],
          rating: 4.2,
          views: 567,
          createdAt: new Date('2024-01-12'),
          author: 'Geography Team'
        },
        {
          id: 'q3',
          title: 'Explain photosynthesis',
          type: 'text',
          subject: 'biology',
          gradeLevel: 'grade_10',
          topic: 'plant biology',
          difficulty: 'medium',
          points: 5,
          content: 'Explain the process of photosynthesis and its importance to life on Earth.',
          sampleAnswer: 'Photosynthesis is the process by which plants convert light energy into chemical energy...',
          tags: ['photosynthesis', 'plants', 'biology'],
          rating: 4.3,
          views: 234,
          createdAt: new Date('2024-01-14'),
          author: 'Biology Department'
        }
      ];
      
      // Apply filters
      let filteredQuestions = mockQuestions;
      
      if (filters.subject) {
        filteredQuestions = filteredQuestions.filter(q => q.subject === filters.subject);
      }
      
      if (filters.questionType) {
        filteredQuestions = filteredQuestions.filter(q => q.type === filters.questionType);
      }
      
      if (filters.searchTerm) {
        const searchTerm = filters.searchTerm.toLowerCase();
        filteredQuestions = filteredQuestions.filter(q => 
          q.title?.toLowerCase().includes(searchTerm) ||
          q.content?.toLowerCase().includes(searchTerm) ||
          q.tags?.some(tag => tag.toLowerCase().includes(searchTerm))
        );
      }
      
      set({
        questions: loadMore ? [...questions, ...filteredQuestions] : filteredQuestions,
        hasMore: false,
        isLoading: false
      });
      
    } catch (error) {
      console.error('Error loading questions:', error);
      set({ error: error.message, isLoading: false });
    }
  },

  // Load categories
  loadCategories: async () => {
    const mockCategories = {
      subjects: [
        { value: 'mathematics', label: 'Mathematics' },
        { value: 'physics', label: 'Physics' },
        { value: 'chemistry', label: 'Chemistry' },
        { value: 'biology', label: 'Biology' },
        { value: 'geography', label: 'Geography' }
      ],
      questionTypes: [
        { value: 'math', label: 'Mathematical' },
        { value: 'multiple-choice', label: 'Multiple Choice' },
        { value: 'true-false', label: 'True/False' },
        { value: 'text', label: 'Text Answer' }
      ],
      difficulties: [
        { value: 'easy', label: 'Easy' },
        { value: 'medium', label: 'Medium' },
        { value: 'hard', label: 'Hard' }
      ]
    };
    
    set({ categories: mockCategories });
  }
}));